module.exports = __webpack_public_path__ + "img/login-failed.661d35bb.svg";